import * as React from 'react';
import { observer } from 'mobx-react';
import { Channel } from '../../../utils/saga-utils';
import { ModalDialog, IModalDialogButton } from '../../../components/modal-dialog';
import { VirtualTerminalFormViewModel } from '../form/virtual-terminal-form-view-model';
import { PaymentMethod } from './payment-entry-model';

export namespace PaymentMethodRemoveDialogUserAction {
	export class Confirm { }

	export class Cancel { }
}

export type PaymentMethodRemoveDialogUserAction = typeof PaymentMethodRemoveDialogUserAction[keyof typeof PaymentMethodRemoveDialogUserAction]['prototype'];

@observer
export class PaymentMethodRemoveDialog extends React.Component<{
	paymentMethod: PaymentMethod,
	formViewModel: VirtualTerminalFormViewModel,
	userActionChannel: Channel<PaymentMethodRemoveDialogUserAction>,
}> {
	render() {
		const { processingRemovePaymentMethod } = this.props.formViewModel;

		const buttons: (IModalDialogButton | JSX.Element)[] = [
			{ label: 'No', dismiss: true, isPrimary: false, hideOnProgress: true },
			<button type="button" key="confirm" className="btn btn-default" onClick={this.handleConfirmClick} disabled={processingRemovePaymentMethod}>
				Yes
			</button>
		];
		return (
			<ModalDialog title="Remove payment method" buttons={buttons} showAlert={false} inProgress={processingRemovePaymentMethod}>
				This payment method is used for 1 or more recurring schedules. Removing this payment method will cancel those schedules. Are you sure you want to remove it?
			</ModalDialog>
		);
	}

	handleConfirmClick = () => {
		const { userActionChannel } = this.props;
		userActionChannel.put(new PaymentMethodRemoveDialogUserAction.Confirm());
	}
}
